import CrowdfundingPropertyError from './CrowdfundingPropertyError';
class CrowdfundingPropertyNotFound extends CrowdfundingPropertyError {
    crowdfundingPropertyId;
    constructor(crowdfundingPropertyId, options) {
        super('Crowdfunding property not found', options);
        this.crowdfundingPropertyId = crowdfundingPropertyId;
    }
}
export default CrowdfundingPropertyNotFound;
